import React from "react";
import API_BASE_URL from "../config/apiConfig";


interface ExportScheduleProps {
  startDate: string;
  endDate?: string;
}

const ExportSchedule: React.FC<ExportScheduleProps> = ({ startDate, endDate }) => {
  const handleExport = async (type: "csv" | "xls") => {
    const url = `${API_BASE_URL}/appointments/export-table?export_type=${type}&start_date=${startDate}${
      endDate ? `&end_date=${endDate}` : ""
    }`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `orar_${startDate}.${type}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        const { detail } = await response.json();
        console.log(JSON.stringify(detail));
        throw new Error("Eroare la export.");
      }
    } catch (error) {
      console.error("Eroare la export:", error);
    }
  };

  return (
    <div>
      <button className="primary-btn" onClick={() => handleExport("xls")}>Export Excel</button>
    </div>
  );
};

export default ExportSchedule;
